import { forwardRef } from 'react';
import COutlinedInput from '../input/outlined-input';
import { ICSelect } from 'types/molecules';
import { CMenuItem } from 'components/atoms';
import { useTranslation } from 'react-i18next';

const CSelect = forwardRef<HTMLDivElement, ICSelect>((props, ref) => {
  const { children, SelectProps, ...rest } = props;
  const { t } = useTranslation();

  return (
    <COutlinedInput
      {...rest}
      ref={ref}
      select
      SelectProps={{
        ...SelectProps,
        classes: {
          select: 'flex items-center text-label16 text-neutral-300',
        },
      }}
    >
      {children ?? <CMenuItem disabled>{t('not-found.option')}</CMenuItem>}
    </COutlinedInput>
  );
});

export default CSelect;

// TODO: https://github.com/mui/material-ui/issues/31145
